import { Text, useTheme } from '@querodelivery/uni-react';
import styles from './delivery-average-by-day-box.module.scss';
import { Bar } from '../../../../_config/lib/chartjs';
import { DELIVERY_AVERAGE_BY_DAY_BOX_OPTIONS } from '../../constants';

type ChartData = {
  key: string;
  value: number;
};

interface DeliveryAverageByDayBoxProps {
  total: number;
  values: ChartData[];
}

export const DeliveryAverageByDayBox = ({
  total,
  values,
}: DeliveryAverageByDayBoxProps) => {
  const { color } = useTheme();

  const data = values.map(value => value.value);
  const labels = values.map(value => value.key);
  const lowerValue = Math.min(...data);
  const upperValue = Math.max(...data);

  return (
    <div className={styles.container}>
      <div className={styles.labelContainer}>
        <Text fontWeight="bold" fontSize="md" lineHeight="sm" tone="secondary">
          Média de entregas
        </Text>
      </div>

      <div className={styles.totalValueContainer}>
        <Text fontSize="xxl" fontWeight="semibold" tone="supporting">
          {total.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}
        </Text>
        <Text
          lineHeight="xl"
          fontWeight="medium"
          fontSize="xs"
          tone="supporting"
        >
          por dia
        </Text>
      </div>

      <div className={styles.chartContainer}>
        <Bar
          data={{
            datasets: [
              {
                data,
                label: '',
                backgroundColor: color['color-text-highlight'],
              },
            ],
            labels,
          }}
          options={{
            ...DELIVERY_AVERAGE_BY_DAY_BOX_OPTIONS,
            plugins: {
              ...DELIVERY_AVERAGE_BY_DAY_BOX_OPTIONS.plugins,
              tooltip: {
                ...DELIVERY_AVERAGE_BY_DAY_BOX_OPTIONS.plugins?.tooltip,
                callbacks: {
                  label(context) {
                    const value = context.parsed.y || 0;
                    return `${value} entregas`;
                  },
                },
              },
            },
            scales: {
              ...DELIVERY_AVERAGE_BY_DAY_BOX_OPTIONS.scales,
              y: {
                ...DELIVERY_AVERAGE_BY_DAY_BOX_OPTIONS.scales?.y,
                min: lowerValue - lowerValue / 3,
                max: upperValue + upperValue / 3,
              },
            },
          }}
        />
      </div>
      <Text
        fontSize="xxs"
        fontWeight="regular"
        style={{ color: color['color-base-border-2'] }}
        alignment="center"
      >
        O gráfico apresenta a quantidade de entregas de acordo com o dia da
        semana, considerando o período da missão.
      </Text>
    </div>
  );
};
